import { ReactElement, useCallback } from "react";
import {
	ActivityInvocation,
	isInvocableAvailableNotificationViewModel
} from "client/Features/ActivityFeed/Activity/Invocation/ActivityInvocation";
import { AvailableNotificationViewModel } from "client/Api/Notifications/notifications";
import { useActivityFeedStore } from "client/Features/ActivityFeed/store";

export const ActivitiesInvocator = (): ReactElement | null => {
	const invokedActivity: AvailableNotificationViewModel | undefined = useActivityFeedStore(state => state.invokedActivity);
	const clearInvokedActivity: (() => void) = useActivityFeedStore(state => state.clearInvokedActivity);
	const loadUpdates: () => void = useActivityFeedStore(state => state.loadUpdates);

	const dismissInvokedActivityHandler = useCallback(
		(shouldUpdateActivityFeed?: boolean): void => {
			clearInvokedActivity();

			if (shouldUpdateActivityFeed) {
				loadUpdates();
			}
		},
		[clearInvokedActivity, loadUpdates]
	);

	if (invokedActivity && isInvocableAvailableNotificationViewModel(invokedActivity)) {
		return (
			<ActivityInvocation
				activity={invokedActivity}
				onDismiss={dismissInvokedActivityHandler}
			/>
		);
	}

	return null;
};

ActivitiesInvocator.displayName = "ActivitiesInvocator";